import React, {useState, useEffect, useContext} from 'react';
import TopUser from '../../components/TopUser';
import { toast } from 'react-toastify';
import { AuthContext } from '../../contexts/AuthContext';
import { ActivityIndicator } from '../../components/Elements/ActivityIndicator';


const Confirmation: React.FC = () => {

    const auth = useContext(AuthContext);
    const [load, setLoad ] = useState(true);
    
    const queryParams = new URLSearchParams(window.location.search);
    const success = queryParams.get('success');
    const plan = queryParams.get('p');
    const key = queryParams.get('session_id');


    async function checkSuccess() {
    if (!key || !auth.user?.email || !plan) {
        toast.error('Houve algum erro no processo, por favor entre em contato', { theme: 'colored' });
        return;
    }
    
    try {
        const res = await fetch('/.netlify/functions/checkSuccess', {
            method: 'POST',
                body: JSON.stringify({
                    key,
                    email: auth.user.email,
                    plan,
                }),
            });
        
            if (!res.ok) {
            const err = await res.text();
            toast.error(err, { theme: 'colored' });
            return;
            }
        
            const newSubscribe = await res.json();
        
            const newUser = {
                id: Number(auth.user.id),
                email: String(auth.user.email),
                planSignature: Number(plan),
                idCustomer: newSubscribe.customer,
                idSubscription: newSubscribe.subscription,
                dateSignature: new Date(newSubscribe.current_period_start * 1000).toLocaleDateString(),
                dateValSignature: new Date(newSubscribe.current_period_end * 1000).toLocaleDateString(),
                statusSignature: newSubscribe.status,
            };
            auth.updateUser({ ...auth.user, ...newUser });
            setLoad(false);
        } catch (err) {
            toast.error('Erro ao tentar atualizar, entre em contato com o suporte.', { theme: 'colored' });
        }
    }
      

    const trynoreaload = async () => { await checkSuccess() };
    useEffect(() =>{        
        let mounted = true;
        if(mounted){
            if(success === 'true' && load){
                trynoreaload();
            }
        }
        return function cleanup() {
            mounted = false
        }
    }) // eslint-disable-line

    return(
    <>
        <div className='simpleflex minHsimpleflex'>            
            <h1 className='marg0'>
                Confirmação
                <span>Muito obrigado</span>
            </h1>
            <TopUser />
        </div>

        <div className="contentpage" style={{display: 'flex', alignItems: "center", justifyContent: 'center'}}> 
        {!load ?
            <div style={{maxWidth: '400px', textAlign: 'center'}}>
                <span className="material-icons-round"  style={{fontSize: '4rem'}}>receipt_long</span>
                <h1 className='orangecolor'>
                    SUCESSO              
                </h1>
                <h3>Assinatura foi realizada com sucesso!</h3> 
                <p>
                Obrigado pela sua confiança em nós, aproveite os seus novos recursos e caso tenha 
                alguma dúvida ou qualquer problema entre em contato conosco agora mesmo.
                <br /><br />
                Obrigado.
                </p>
            </div>
        :
            <ActivityIndicator />
        }

            <div className="gradfooter"></div>
        </div>        
    </>
  );
}

export default Confirmation;